import { act, useEffect, useState, useRef } from 'react'
import shopify from '../../assets/shopifybag.png'
import profileicon from '../../assets/botprofileicon.png'
import mobileimage from '../../assets/botcustomization_mobileimage.png'
import { HexColorPicker } from 'react-colorful' // Using HexColorPicker for hex format directly
// import "react-color-palette/css";
import { apiFetch } from '../../services/apihelper'
import { toast, ToastContainer } from 'react-toastify'
import defaultlaunchericon from '../../assets/botcustomization/chaticon.png'
import defaultboticon from '../../assets/botcustomization/magbotlogo.png'
import { getStorebyID, DatasetSync, Validatescript } from '../../services/data'
import validateJSON from '../../util/jsonvalidation'
import { SketchPicker } from 'react-color'
import ConvoFlow from './component/convo_flow'
import GeneralSettings from './component/general_tab'
import '../../styles/botcustom.css'
import IonIcon from '@reacticons/ionicons'
import { useLocation, useParams } from 'react-router-dom'
// import { LazyLoadImage } from 'react-lazy-load-image-component'
import imageplaceholder from '../../assets/botcustomization/imageplaceholder.png'
import TooltipWalkthrough from '../../util/walkthrough'
// import 'react-lazy-load-image-component/src/effects/blur.css' // Optional effect
import { useSubscription } from '../../context/subscriptionprovider'
import AccessRestrictedOverlay from '../../components/restrictoverlay'
import useChatbotLoader from '../../util/chatbotloader'
import ChatbotLoader, { rebuildChatbot } from '../../util/loadExternalScript'
import ConversationFlowTab from './component/ConversationflowTab'
import PublishTab from './component/PublishTab'
import ColorThemeTab from './component/ColorTheme'
import BotUITab from './component/BotUiTab'
import BotInstructionsTab from './BotInstructionsTab'

const BotCustomization = () => {
  const [activeTab, setActiveTab] = useState('Bot UI')
  const [color, setColor] = useState('#7c50dd')
  const [valueRight, setValueRight] = useState('20') // Position from Right value
  const [valueLeft, setValueLeft] = useState('20') // Position from Left value
  const [valueBottom, setValueBottom] = useState(20) // Position from Bottom value
  const [positionSide, setPositionSide] = useState('right') // Toggle between left and right
  const [launcherImagePreview, setLauncherImagePreview] = useState(
    'https://cdn.shopify.com/s/files/1/0667/7112/4443/files/chaticon.jpg?v=1731663617'
  )
  const [ChecklauncherImagePreview, SetChecklauncherImagePreview] =
    useState(true)
  const [botImagePreview, setBotImagePreview] = useState(
    'https://cdn.shopify.com/s/files/1/0667/7112/4443/files/magbotlogo.420005e6d5a82ea06361_2.png?v=1731663617'
  )
  const [CheckbotImagePreview, SetCheckbotImagePreview] = useState(true)
  const [botName, setBotName] = useState('Hello there! 👋') // State for Bot name
  const [welcomeMessage, setWelcomeMessage] = useState(
    'Welcome to MagBot Pro<br>Im here to assist you with your questions.'
  ) // State for Welcome message
  const [storeId, setstoreId] = useState('')
  const [storeName, setstoreName] = useState('')
  const [checkType, setcheckType] = useState('')
  const [showHint, setshowHint] = useState(true)
  const [positionlabel, setpositionlabel] = useState('Position From Right')
  const location = useLocation()
  const hasSynced = useRef(false) // Track if function has run
  const { fromSource, storeid, from } = location.state || {}
  const { isRestricted, activePlan, limitedPermission } = useSubscription()
  const [jsbundle, setjsbundle] = useState('') // Manage chatbot script URL
  const [GetStoreId, setGetStoreId] = useState('') // Manage storeId state
  const [isDomainVerified, setIsDomainVerified] = useState(false)
  const params = useParams()

  // ✅ Extract store_id from URL (params or pathname)
  const getStoreIdFromUrl = () => {
    if (params?.store_id) return params.store_id
    const pathParts = location.pathname.split('/')
    console.log(pathParts[1])
    return pathParts[1] || null
  }

  const urlstoreid = getStoreIdFromUrl()

  // useChatbotLoader(jsbundle, GetStoreId)

  // Loads on component mount
  useEffect(() => {
    if (localStorage.getItem('flag')) {
      setActiveTab('Conversation Flow')
      localStorage.removeItem('flag')
      return
    }
    handleTriggerBot(false)
  }, [])

  useEffect(() => {
    if (
      isRestricted ||
      !limitedPermission ||
      limitedPermission.ticket_management === false
    ) {
      console.warn('Bot config fetch restricted due to permission limitations.')
      return
    }
    const validatescript = async () => {
      const getstore = await getStorebyID(urlstoreid)
      const data = {
        url: 'https://' + getstore?.data?.name,
        storeId: urlstoreid
      }
      const res = await Validatescript(data)
      console.log(res)
    }
    validatescript()
  }, [])

  // Handle triggerpreview event
  useEffect(() => {
    const handleTriggerPreview = event => {
      if (event.detail) {
        setGetStoreId('')
        setjsbundle('')
        localStorage.setItem('flag', true)
        rebuildChatbot()
        setTimeout(() => {
          handleTriggerBot(true)
        }, 1000)
      }
    }

    window.addEventListener('triggerpreview', handleTriggerPreview)
    return () =>
      window.removeEventListener('triggerpreview', handleTriggerPreview)
  }, [])

  const handleTriggerBot = stay => {
    const storeId = urlstoreid
    if (storeId) {
      if (stay) {
        setActiveTab('Conversation Flow')
        localStorage.removeItem('flag')
      }
      if (window.chatbotConfig) {
        window.chatbotConfig.open = true
      }
    } else {
      console.warn('Missing store_id. Cannot trigger bot.')
    }
  }

  useEffect(() => {
    console.log(limitedPermission)
  })

  // useEffect(() => {
  //   const datasync = async () => {
  //     if (
  //       !hasSynced.current &&
  //       localStorage.getItem('store_id') &&
  //       localStorage.getItem('onboarding')
  //     ) {
  //       hasSynced.current = true // Mark as executed
  //       const response = await DatasetSync(localStorage.getItem('store_id'))
  //       if (response.success) {
  //         toast.success(response.message, {
  //           position: 'bottom-center'
  //         })
  //       }
  //       hasSynced.current = false
  //       localStorage.removeItem('onboarding')
  //     }
  //   }

  //   datasync()
  // }, []) // Empty dependency array ensures it runs once

  const scriptCode = `<script 
  src="${process.env.REACT_APP_API_URL}/js/loader.bundle.js" 
  async 
  data-store-id="${urlstoreid}" 
  id="chatbot-script-loader" 
  defer
></script>`

  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(scriptCode)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000) // Reset copied state after 2 seconds
  }

  useEffect(() => {
    // Set admin to true when the component is mounted
    if (
      window.chatbotConfig &&
      window.location.pathname.includes('bot-customization')
    ) {
      if (window.innerWidth > 684 && positionSide == 'right') {
        setTimeout(() => {
          if (
            window.chatbotConfig &&
            typeof window.chatbotConfig.reloadInitConfig === 'function'
          ) {
            window.chatbotConfig.open = true
          }
        }, 2000)
      }
    }
  }) // Empty dependency array ensures this runs only once on mount and unmount

  useEffect(() => {
    if (urlstoreid) {
      setstoreId(urlstoreid)
    }
  }, [color])

  useEffect(() => {
    const GetStoreName = async () => {
      if (urlstoreid) {
        const getStorename = await getStorebyID(urlstoreid)
        console.log(getStorename)
        setstoreName(
          getStorename?.data?.name?.replace('.myshopify.com', '') ?? ''
        )
        setcheckType(getStorename?.data?.type ?? '')
      }
    }
    if (isRestricted || !limitedPermission) {
      console.warn('Bot config fetch restricted due to permission limitations.')
      return
    }
    GetStoreName()
  }, [storeName, checkType])

  // console.log(storeName)

  const fetchBotConfig = async () => {
    if (isRestricted || !limitedPermission) {
      console.warn('Bot config fetch restricted due to permission limitations.')
      return
    }
    try {
      const response = await apiFetch(`bots?store_id=${storeId}`)
      if (response.success && response.data) {
        if (response.data.length === 0) {
          // window.chatbotConfig.botLauncherImageUrl = defaultlaunchericon
          // window.chatbotConfig.botImageUrl = defaultboticon
          setBotName(window.chatbotConfig.title)
          setWelcomeMessage(window.chatbotConfig.subtitle)
          setValueBottom(window.chatbotConfig.bottom.replace('px', ''))
          setValueRight(window.chatbotConfig.right.replace('px', ''))
          setValueLeft(window.chatbotConfig.left.replace('px', ''))
          setColor(window.chatbotConfig.colorScheme)
          setLauncherImagePreview(
            window.chatbotConfig.botLauncherImageUrl || null
          )
          setBotImagePreview(window.chatbotConfig.botImageUrl || null)
          if (window.chatbotConfig.right === 'auto') {
            setPositionSide('left')
          } else {
            setPositionSide('right')
          }
        } else {
          const botConfig = validateJSON(response.data[0].config)
          // window.chatbotConfig = { ...botConfig };
          setBotName(botConfig.title || '')
          setWelcomeMessage(botConfig.subtitle || '')
          setValueRight(botConfig.right.replace('px', ''))
          setValueLeft(botConfig.left.replace('px', ''))
          setValueBottom(botConfig.bottom.replace('px', ''))
          setLauncherImagePreview(botConfig.botLauncherImageUrl || null)
          // window.chatbotConfig.botLauncherImageUrl =
          //   botConfig.botLauncherImageUrl
          setBotImagePreview(botConfig.botImageUrl || null)
          // window.chatbotConfig.botImageUrl = botConfig.botImageUrl
          setColor(botConfig.colorScheme)
          if (botConfig.right === 'auto') {
            setPositionSide('left')
          } else {
            setPositionSide('right')
          }
        }
      }
    } catch (error) {
      console.error('Error fetching bot config:', error)
    }
  }

  const handleResetConfig = async () => {
    fetchBotConfig()
    return
    if (storeId) {
      const response = await apiFetch(`bots?store_id=${storeId}`)
      const botConfig = validateJSON(response.data[0].config)
      // console.log(botConfig)
      setBotName(botConfig.title || '')
      setWelcomeMessage(botConfig.subtitle || '')
      setValueRight(botConfig.right.replace('px', ''))
      setValueLeft(botConfig.left.replace('px', ''))
      setValueBottom(botConfig.bottom.replace('px', ''))
      setLauncherImagePreview(botConfig.botLauncherImageUrl || null)
      window.chatbotConfig.botLauncherImageUrl = botConfig.botLauncherImageUrl
      setBotImagePreview(botConfig.botImageUrl || null)
      window.chatbotConfig.botImageUrl = botConfig.botImageUrl
      setColor(botConfig.colorScheme)
    }
  }

  // Get bot configuration when store_id is available
  useEffect(() => {
    if (storeId) {
      fetchBotConfig()
    }
  }, [storeId])

  const handleRightChange = e => {
    const newValue = e.target.value
    setValueRight(newValue) // Update the slider value for right
    window.chatbotConfig.right = `${newValue}px` // Update the chatbotConfig right value with 'px'
  }

  const handleLeftChange = e => {
    const newValue = e.target.value
    setValueLeft(newValue) // Update the slider value for left
    window.chatbotConfig.left = `${newValue}px` // Update the chatbotConfig left value with 'px'
  }

  const handleBottomChange = e => {
    setValueBottom(e.target.value) // Handle bottom position change
  }

  const handleTabClick = tab => {
    setActiveTab(tab)
  }

  const handlePositionToggle = async pos => {
    if (pos === 'left') {
      setPositionSide('left')
      setValueLeft('20')
      setValueRight('auto')
      window.chatbotConfig.right = 'auto'
      window.chatbotConfig.left = '20px'
    } else {
      setPositionSide('right')
      setValueLeft('auto')
      setValueRight('20')
      window.chatbotConfig.right = '20px'
      window.chatbotConfig.left = 'auto'
    }
    // console.log(window.chatbotConfig.right, window.chatbotConfig.left)

    return
    const response = await apiFetch(`bots?store_id=${storeId}`)
    const botConfig = validateJSON(response.data[0]?.config) // Safely accessing config
    console.log(botConfig)

    if (pos === 'left') {
      // Set the right value to 'auto' and update the left position
      window.chatbotConfig.right = 'auto'
      setPositionSide('left')

      // If botConfig.left is null or an empty string, set it to '20px'
      if (botConfig === null || botConfig.left === '') {
        console.log(true)
        setValueLeft(20) // Set default value to 20 (as a number)
        window.chatbotConfig.left = '20px' // Update chatbotConfig left with '20px'
      } else {
        console.log(false)
        // Parse the current left value and set it
        setValueLeft(parseInt(botConfig.left.replace('px', ''))) // Ensure it's a number without 'px'
        window.chatbotConfig.left = botConfig.left // Set chatbotConfig left from botConfig
      }
    } else if (pos === 'right') {
      // Set the left value to 'auto' and update the right position
      window.chatbotConfig.left = 'auto'
      setPositionSide('right')

      // If botConfig.right is empty or null, set it to a default value of '20px'
      if (!botConfig.right || botConfig.right === '') {
        console.log(true)
        window.chatbotConfig.right = '20px' // Add default right position '20px'
        setValueRight(20) // Set default value to 20
      } else {
        console.log(false)
        // Parse the current right value and set it
        setValueRight(parseInt(botConfig.right.replace('px', ''))) // Ensure it's a number without 'px'
        window.chatbotConfig.right = botConfig.right // Set chatbotConfig right from botConfig
      }
    }

    // Optional: Log to check if values are being updated correctly
    console.log(
      'Updated positions:',
      window.chatbotConfig.left,
      window.chatbotConfig.right
    )
    console.log('Right:', valueRight, 'Left:', valueLeft)
  }

  useEffect(() => {
    if (
      window.chatbotConfig &&
      typeof window.chatbotConfig.reloadInitConfig === 'function'
    ) {
      console.log('Refresh..')
      window.chatbotConfig.title = botName
      window.chatbotConfig.subtitle = welcomeMessage
      window.chatbotConfig.bottom = valueBottom + 'px'
      window.chatbotConfig.right =
        positionSide === 'right' ? valueRight + 'px' : 'auto' // Handling position right value
      window.chatbotConfig.left =
        positionSide === 'left' ? valueLeft + 'px' : 'auto' // Handling position right value
      window.chatbotConfig.colorScheme = `${color}`
    }
  }, [
    botName,
    welcomeMessage,
    valueRight,
    valueLeft,
    valueBottom,
    positionSide,
    color
  ])

  const handleLauncherImageChange = async event => {
    const file = event.target.files[0]
    // console.log(file)
    if (file) {
      // Preview the image
      const reader = new FileReader()
      reader.onloadend = async () => {
        console.log(reader.result)
        setLauncherImagePreview(reader.result)

        // Prepare the form data to send as binary
        const formData = new FormData()
        formData.append('image', file) // Append the file with the correct field name ('image')

        try {
          // Send the file to the server using fetch with the FormData (binary data will be automatically handled)
          // const response = await fetch(
          //   `${process.env.REACT_APP_API_URL}/api/upload/image`,
          //   {
          //     method: 'POST',
          //     body: formData, // Body is the form data which includes the binary file
          //     headers: {
          //       ...(localStorage.getItem('token')
          //         ? {
          //             Authorization: `Bearer ${localStorage.getItem('token')}`
          //           }
          //         : {}) // Include the token in headers if it exists
          //     }
          //   }
          // )

          const response = await apiFetch('upload/image', {
            method: 'POST',
            body: formData
          })

          // Check if the upload was successful
          if (response.success) {
            console.log('uploaded')
            const data = await response
            const uploadedImageUrl = `${process.env.REACT_APP_AWS_URL}${data.data.filename}` // Assumin    g the response contains the URL
            SetChecklauncherImagePreview(false)
            // console.log(uploadedImageUrl)
            // Set the URL in your configuration or state
            if (
              window.chatbotConfig &&
              typeof window.chatbotConfig.reloadInitConfig === 'function'
            ) {
              window.chatbotConfig.botLauncherImageUrl = uploadedImageUrl
            }
            document.getElementById('uploadBotLauncherImage').value = ''
          } else {
            console.error('Failed to upload image')
          }
        } catch (error) {
          console.error('Error uploading image:', error)
        }
      }
      reader.readAsDataURL(file) // Read the file for preview
    }
  }

  const handleBotImageChange = async event => {
    const file = event.target.files[0]
    if (file) {
      // Preview the image
      const reader = new FileReader()
      reader.onloadend = async () => {
        setBotImagePreview(reader.result)

        // Prepare the form data to send as binary
        const formData = new FormData()
        formData.append('image', file) // Append the file with the correct field name ('image')

        try {
          // Send the file to the server using fetch with the FormData (binary data will be automatically handled)
          // const response = await fetch(
          //   `${process.env.REACT_APP_API_URL}/api/upload/image`,
          //   {
          //     method: 'POST',
          //     body: formData, // Body is the form data which includes the binary file
          //     headers: {
          //       ...(localStorage.getItem('token')
          //         ? {
          //             Authorization: `Bearer ${localStorage.getItem('token')}`
          //           }
          //         : {}) // Include the token in headers if it exists
          //     }
          //   }
          // )
          const response = await apiFetch('upload/image', {
            method: 'POST',
            body: formData
          })

          // Check if the upload was successful
          if (response.success) {
            const data = await response
            const uploadedImageUrl = `${process.env.REACT_APP_AWS_URL}${data.data.filename}` // Assumin    g the response contains the URL

            SetCheckbotImagePreview(false)
            // Set the URL in your configuration or state
            if (
              window.chatbotConfig &&
              typeof window.chatbotConfig.reloadInitConfig === 'function'
            ) {
              window.chatbotConfig.botImageUrl = uploadedImageUrl
            }
            document.getElementById('uploadBotImage').value = ''
          } else {
            console.error('Failed to upload image')
          }
        } catch (error) {
          console.error('Error uploading image:', error)
        }
      }
      reader.readAsDataURL(file) // Read the file for preview
    }
  }

  const handleSaveConfig = async () => {
    if (urlstoreid) {
      setstoreId(urlstoreid)
    } else {
      return
    }
    const configData = {
      store_id: storeId,
      config: {
        title: window.chatbotConfig.title,
        subtitle: window.chatbotConfig.subtitle,
        colorScheme: window.chatbotConfig.colorScheme,
        botImageUrl: window.chatbotConfig.botImageUrl,
        botLauncherImageUrl: window.chatbotConfig.botLauncherImageUrl,
        position: 'fixed',
        bottom: window.chatbotConfig.bottom,
        right: window.chatbotConfig.right,
        left: window.chatbotConfig.left
      },
      meta: {}
    }

    try {
      const response = await apiFetch('bots', {
        method: 'POST',
        body: JSON.stringify(configData)
      })

      if (response.success) {
        // console.log("Configuration saved successfully!");
        toast.success('Configuration saved successfully!', {
          autoClose: 3000,
          position: 'bottom-center'
        })
        rebuildChatbot()
        if (window.chatbotConfig) {
          window.chatbotConfig.open = true
        }
      } else {
        // console.error("Failed to save configuration.");
        toast.error('Failed to save configuration.', {
          autoClose: 3000,
          position: 'bottom-center'
        })
      }
    } catch (error) {
      console.error('Error saving configuration:', error)
    }
  }

  // console.log(color);
  const handleHexColorChange = updatedColor => {
    setColor(updatedColor.hex) // Only update the hex value
  }
  if (isRestricted) {
    return (
      <div className='min-h-[29.1rem] h-full relative'>
        <AccessRestrictedOverlay
          content={
            'Upgrade your plan to access advanced customization options. Modify appearance, behavior, and interaction settings to suit your needs.'
          }
        />
      </div>
    )
  }
  return (
    <div className='pt-9 pb-9 pl-4 pr-4 md:pl-7 md:pr-7 block relative'>
      <div className='block'>
        <div className='flex space-x-2 items-center'>
          {/* <img src={shopify} alt="Shopify Bag" className='w-[32px] h-[32px]' /> */}
          <h1 className='text-[#252530] font-extrabold text-[23px]'>
            Customize Your Bot
          </h1>
        </div>
        <p className='font-medium mt-1 text-[#252530] text-[12px]'>
          Personalize Your Bot for Enhanced User Engagement
        </p>
      </div>

      {/* Tab Content */}
      <div className='w-full flex gap-7'>
        <div className='mt-6 flex flex-col w-full '>
          <div className='pb-4 w-full sm:w-[50%] overflow-x-auto no-scrollbar'>
            <ul className='inline-flex gap-[30px] justify-between min-w-max sm:border-b-[1px] border-[#786E6E] border-opacity-20 border-0 self-start'>
              {[
                { name: 'Bot UI', className: 'botui' },
                { name: 'Color Theme', className: 'colortheme' },
                {
                  name: 'Conversation Flow',
                  className: 'conversationflow'
                },
                { name: 'Bot Instructions', className: 'botinstructions' },

                // { name: 'General Setting', className: 'generalsetting' },
                { name: 'Publish', className: 'publish' }
              ].map(({ name, className }) => (
                <li
                  key={name}
                  onClick={() => handleTabClick(name)}
                  className={` cursor-pointer pb-2 whitespace-nowrap ${
                    activeTab === name
                      ? 'border-b-[3px] border-[#7C50DD] pb-2 font-[700] text-[#252530] text-[15px]'
                      : 'text-gray-500 font-medium text-[15px]'
                  }`}
                >
                  <p className={`${className} inline-flex`}> {name} </p>
                </li>
              ))}
            </ul>
          </div>

          {activeTab === 'Bot UI' && (
            <BotUITab
              ChecklauncherImagePreview={ChecklauncherImagePreview}
              CheckbotImagePreview={CheckbotImagePreview}
              limitedPermission={limitedPermission}
              launcherImagePreview={launcherImagePreview}
              imageplaceholder={imageplaceholder}
              handleLauncherImageChange={handleLauncherImageChange}
              botImagePreview={botImagePreview}
              handleBotImageChange={handleBotImageChange}
              botName={botName}
              setBotName={setBotName}
              welcomeMessage={welcomeMessage}
              setWelcomeMessage={setWelcomeMessage}
              positionSide={positionSide}
              handlePositionToggle={handlePositionToggle}
              setpositionlabel={setpositionlabel}
              positionlabel={positionlabel}
              valueRight={valueRight}
              valueLeft={valueLeft}
              handleRightChange={handleRightChange}
              handleLeftChange={handleLeftChange}
              valueBottom={valueBottom}
              handleBottomChange={handleBottomChange}
              handleSaveConfig={handleSaveConfig}
              handleResetConfig={handleResetConfig}
            />
          )}
          {activeTab === 'Color Theme' && (
            <ColorThemeTab
              color={color}
              handleHexColorChange={handleHexColorChange}
              handleSaveConfig={handleSaveConfig}
              handleResetConfig={handleResetConfig}
            />
          )}

          {activeTab === 'Conversation Flow' && (
            <ConversationFlowTab limitedPermission={limitedPermission} />
          )}

          {activeTab === 'Bot Instructions' && (
            <BotInstructionsTab
              urlstoreid={urlstoreid}
              storeId={urlstoreid}
              limitedPermission={limitedPermission}
              onSavePartial={async partial => {
                window.chatbotConfig = {
                  ...(window.chatbotConfig || {}),
                  ...partial
                }
              }}
            />
          )}

          {activeTab === 'Publish' && (
            <PublishTab
              checkType={checkType}
              storeName={storeName}
              scriptCode={scriptCode}
              copied={copied}
              handleCopy={handleCopy}
              isDomainVerified={isDomainVerified}
              urlstoreid={urlstoreid}
            />
          )}

          {/* <img src={mobileimage} alt="" className='mt-[-8%] max-h-[450px] self-start' /> */}
        </div>
      </div>
      <ToastContainer />
      <TooltipWalkthrough pageKey={'/bot-customization'} />
      <ChatbotLoader />
    </div>
  )
}

export default BotCustomization
